import React from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import { CoreLink } from '../../../components';

import './style.scss';

const FooterSecondaryMenu = () => {
  return (
    <div className="FooterSecondaryMenu col-sm-12 col-md-5">
      <Menu id="footer-other">
        {(items) => {
          return (
            <div className="FooterSecondaryMenu__items">
              {items.map((item, index) => {
                const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
                const href = item.getIn(['link', 'url']);
                const title = item.getIn(['link', 'title'], 'Untitled');
                return (
                  <li key={`menu--footer-other--menu-item-${title}:${href}`} className="menu--footer-other--menu-item">
                    <CoreLink
                      to={href}
                      target={attrs.get('target')}
                    >
                      {title}
                    </CoreLink>
                  </li>
                );

              })}
            </div>
          );
        }}
      </Menu>
    </div>
  );
};

export default FooterSecondaryMenu;
